import { Middleware } from '@reduxjs/toolkit';

const loaderMiddleware: Middleware = (store) => (next) => (action) => {
  const typedAction = action as { type: string };
  if (typedAction.type.endsWith('/pending')) {
    // store.dispatch(showLoader());
  }
  if (typedAction.type.endsWith('/fulfilled') || typedAction.type.endsWith('/rejected')) {
    // store.dispatch(hideLoader());
  }
  return next(action);
};

export default loaderMiddleware;
